
<template>
    <div>
        <!-----------------  responsive menu -------------------->
        <v-navigation-drawer absolute v-model="sideNav" width="340" class="hidden-sm-and-up mobile-menu elevation-bg-color">
            <v-list >

                <SettingsList
                    :side-nav="sideNav"
                    @closeSideNav="closeSideNav"
                    :app-type="appType"
                    :get-role="getRole"/>

            </v-list>


            <v-btn v-if="!getUserData.embedded && isScoringPage"
                   @click="goToHomePage"
                   id="btnHeaderSmallDisplayFinishAssessment"
                   class="menu-settings quit"
                   flat
                   :ripple="false"
                   color="primary"
            >
                <span>{{text('api.button.header.bar.home')}}</span>
            </v-btn>

            <v-btn v-else-if="!getUserData.embedded && !isScoringPage"
                   @click="quitAssessment"
                   id="btnHeaderSmallDisplayCancelAssessment"
                   class="menu-settings quit" flat :ripple="false" color="primary">
                <span>{{text('api.button.header.bar.quit')}}</span>
            </v-btn>

            <v-btn v-else-if="getUserData.embedded && isScoringPage &&
                         getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON')"
                   class="menu-settings quit"
                   @click="onAssessmentEndFinishButton"
                   id="btnHeaderSmallDisplayFinishAssessmentGoToUrl"
                   flat :ripple="false"
                   color="primary">
                <span>{{text('api.button.header.bar.home')}}</span>
            </v-btn>
        </v-navigation-drawer>

        <!----------------- general menu ---------------------->
        <v-toolbar  fixed class="header header-menu header-menu-medical-device">

            <v-toolbar-side-icon
                v-if="!sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
            </v-toolbar-side-icon>

            <v-toolbar-side-icon
                v-if="sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
                <close-icon :svg-fill-class="'svg-secondary-color'"/>
            </v-toolbar-side-icon>

            <v-toolbar-title v-if="logo">
                <img v-bind:src="logo" alt="smass logo"  class="logo">
            </v-toolbar-title>

            <v-toolbar-items class="pages hidden-md-and-down" v-if="!getUserData.embedded">
                <div class="height-full patients-info-top" style="margin-left: 5px;">
                    <span  class="page-title" v-html="title"></span>
                    <patient-info></patient-info>
                </div>
            </v-toolbar-items>

            <v-spacer></v-spacer>

            <v-toolbar-items id="header-bar-toolbar-items" class="language-dropdown-container no-margin-right">
                <div class="header-bar-medical-device-item-wrapper">
                    <assessment-alerts v-if="!getAppPropertyStudyAccess"></assessment-alerts>
                    <div @mousedown="showCommentAction" @mousedown.stop v-if="!mustShowPatientPanel || !isNotRequiredPage">
                        <svg-button
                            :margin-left="8"
                            :margin-right="8"
                            :button-height="36"
                            :button-width="36"
                        >
                            <comment-icon :height="36" :width="36" ></comment-icon>
                        </svg-button>

                    </div>

                    <vital-params-dropdown-form
                        v-if="pageWidth > 430"
                        @setIsKeyboardNav="setIsKeyboardNav"
                        :page-shortcut-nav="this.shortcutNav"
                        ref="vitalParamsDropdownForm"
                        ></vital-params-dropdown-form>

                    <svg-button
                        v-if="isScoringPage"
                        @click.native="showSummaryPopup"
                        :margin-left="8"
                        :margin-right="8"
                        :button-height="36"
                        :button-width="36"
                        class="margin-right-xxs hidden-xs-only ambulance-scoring scoring-summary-page">
                        <assessment-icon :width="36" :height="36"/>
                    </svg-button>
                </div>


                <div class="header-bar-medical-device-item-wrapper">
                    <svg-button
                        :margin-left="8"
                        :margin-right="8"
                        :button-width="36"
                        :button-height="36"
                        @click.native="showMedicalDeviceInfoPopup"
                    >
                        <medical-device-info-icon :height="36" :width="36" class="show-info-popup"/>
                    </svg-button>
                </div>



                <div class="header-bar-medical-device-item-wrapper hidden-md-and-down">
                    <div class="add-vertical-border"></div>
                </div>

                <SettingsMenu
                    class="hidden-xs-only"
                    :app-type="appType" :get-role="getRole"></SettingsMenu>

                <div class="header-bar-medical-device-item-wrapper">
                    <v-btn v-if="(getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('PDF') > -1
                                || getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('EMAIL') > -1)
                                && isScoringPage"
                           to="/assessment-share"
                           id="btnHeaderShareAssessment"
                           class="share-button menu-settings home scoring text-uppercase"
                           flat
                    >
                        {{text('api.button.header.bar.share')}}
                    </v-btn>
                </div>


               <div class="header-bar-medical-device-item-wrapper hidden-xs-only">
                   <v-btn v-if="!getUserData.embedded && isScoringPage"
                          @click="goToHomePage"
                          id="btnHeaderFinishAssessment"
                          class="finish-button menu-settings text-uppercase"
                          :class="{'bg-color-primary-important' : isScoringPage}"
                          :ripple="false"
                          flat
                   >
                       <span class="color-on-primary-text">{{text('api.button.header.bar.home')}}</span>
                   </v-btn>

                   <v-btn v-else-if="!getUserData.embedded && !isScoringPage"
                          @click="quitAssessment"
                          id="btnHeaderCancelAssessment"
                          class="cancel-button menu-settings text-uppercase"
                          :class="{'bg-color-primary-important' : isScoringPage}"
                          :ripple="false"
                          flat
                   >
                       <span>{{text('api.button.header.bar.quit')}}</span>
                   </v-btn>
               </div>

                <v-btn v-if="getUserData.embedded && isScoringPage &&
                             getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON')"
                       @click="onAssessmentEndFinishButton"
                       id="btnHeaderFinishAssessmentGoToUrl"
                       class="menu-settings hidden-xs-only text-uppercase color-on-primary-text"
                       :class="{'bg-color-primary-important' : isScoringPage}"
                       :ripple="false"
                       flat
                >
                    <span>{{text('api.button.header.bar.home')}}</span>
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar class="patients-info-top patients-info-small-devices hidden-lg-and-up" fixed style="text-align: left;">
            <div class="height-full" style="margin-left: 5px;">
                <span class="page-title" v-html="title"></span>
                <patient-info></patient-info>
            </div>
            <svg-button
                v-if="isScoringPage"
                @click.native="showSummaryPopup"
                :margin-right="12"
                :button-height="36"
                :button-width="36"
                class="margin-right-l hidden-sm-and-up ambulance-scoring scoring-summary-page">
                <assessment-icon :width="36" :height="36"/>
            </svg-button>
        </v-toolbar>
        <patient-comment-popup></patient-comment-popup>

        <!-- INFO POPUP -->
        <info-popup></info-popup>

        <!-- SCORING POPUP -->
        <scoring-popup></scoring-popup>

        <!-- URGENT POPUP -->
        <urgent-popup></urgent-popup>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import LoginPage from '../../../common/components/login/LoginPage';
import PatientInfo from "../../../common/components/shared/PatientInfo";
import PatientProfile from "../assessment-start/PatientProfile";
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import InfoPopup from '../../../common/components/shared/InfoPopup';
import Vue from "vue";
import axios from 'axios/dist/axios';
import SettingsIcon from "../../../common/components/svg/shared/settingsIcon";
import InfoIcon from "../../../common/components/svg/topBarAlerts/infoIcon";
import MedicalDeviceInfoIcon from "../../../common/components/svg/shared/medicalDeviceInfoIcon";
import CommentIcon from "../../../common/components/svg/shared/commentIcon";
import SvgButton from "../../../common/components/shared/SvgButton";
import AssessmentIcon from "../../../common/components/svg/shared/assessmentIcon";
import BaseSwitch from "../../../common/components/shared/BaseSwitch";
import LightThemeIcon from "../../../common/components/svg/shared/lightThemeIcon";
import DarkThemeIcon from "../../../common/components/svg/shared/darkThemeIcon";
import HighContrastDarkIcon from "../../../common/components/svg/shared/highContrastDarkIcon";
import HighContrastLightIcon from "../../../common/components/svg/shared/highContrastLightIcon";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import SettingsMenu from "../../../common/components/shared/SettingsMenu";
import ScoringPopup from "../../../common/components/shared/ScoringPopup";
import UrgentPopup from "../../../common/components/shared/UrgentPopup";
import SettingsList from "../../../common/components/shared/SettingsList";
import PatientCommentPopup from "./PatientCommentPopup";
import VitalParamsDropdownForm from "./VitalParamsDropdownForm";

export default {
        name: 'HeaderBarMedicalDevice',
        components: {
            VitalParamsDropdownForm,
            PatientCommentPopup,
            SettingsList,
            UrgentPopup,
            ScoringPopup,
            SettingsMenu,
            CloseIcon,
            HighContrastLightIcon,
            HighContrastDarkIcon,
            DarkThemeIcon,
            LightThemeIcon,
            BaseSwitch,
            AssessmentIcon,
            SvgButton,
            CommentIcon,
            MedicalDeviceInfoIcon,
            InfoIcon,
            SettingsIcon,
            LoginPage,
            PatientInfo,
            PatientProfile,
            AssessmentAlerts,
            InfoPopup

        },
        data () {
            return {
                sideNav: false,
                account: false,
                currentItem: 'home',
                settings: false,
                mustShowPatientPanel: true,
                clickedElement:'',
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                arrowDownPlugin: Vue.ArrowDown.arrowDownSvg,
                menuIconPlugin: Vue.MenuIcon.menuIconSvg
            }
        },
        props: ['title', 'shortcutNav'],

        beforeMount() {
            let mustShowPatientPanel = sessionStorage.getItem('must-show-patient-panel');
            if (mustShowPatientPanel !== null) {
                this.mustShowPatientPanel = (mustShowPatientPanel == 'false') ? false : true;
            }

            let mustShowPriorityList = sessionStorage.getItem('must-show-priority-list');
            if(this.getPriorityListVal && mustShowPriorityList) {
                if (mustShowPriorityList !== null) {
                    this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                        if (mustShowPriorityList) {
                            this.$router.push('/symptoms-list');
                        } else {
                            this.$router.push('/symptoms-questions');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                        if (mustShowPriorityList) {
                            this.$router.push('/assessment-start-list');
                        } else {
                            this.$router.push('/assessment-start');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    } else {
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);
                        this.settings = false;

                    }
                }
            }

            let mustShowEvaluationScreen = sessionStorage.getItem('must-show-evaluation-screen');
            if(this.getEvaluationScreenVal && mustShowEvaluationScreen) {
                if (mustShowEvaluationScreen !== null) {
                    this.$store.commit('TranslationStore/setMustShowEvaluationPage', mustShowEvaluationScreen);
                }
            }
        },

        created() {
            window.addEventListener('keydown', this.handleKeyDowns);
        },

        destroyed() {
            window.removeEventListener('keydown', this.handleKeyDowns);
        },

        mounted() {

            this.$store.commit('VitalParametersStore/resetStore');

            let selectedInputIcon = document.getElementsByClassName('language-option');
            if (selectedInputIcon) {
                let selectLanguage = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
                selectLanguage[0].innerHTML = this.arrowDownPlugin();
            }


            // When mounted we replace the menu icon with the svg.
            let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
            if (menuIcon) {
                menuIcon.innerHTML = this.menuIconPlugin();
            }
        },

        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                getSelectedLang: 'TranslationStore/getSelectedLang',
                isAdmin: 'UserStore/getIsAdmin',
                getFullName: 'UserStore/getFullName',
                getRole: 'UserStore/getRole',
                logo: 'TranslationStore/getLogo',
                appType: 'TranslationStore/getAppTypeName',
                getUserData: 'UserStore/getUserData',
                getMustShowEvaluationPage: 'TranslationStore/getMustShowEvaluationPage',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                getShowUserComment: 'TranslationStore/getShowUserComment',
                getDecisionIcon: 'AssessmentAlertsStore/getDecisionIcon',
                getMustShowMedicalDeviceInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
                getShowUserCommentNoShortcut: 'TranslationStore/getShowUserCommentNoShortcut',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
                getPriorityListVal: 'TranslationStore/getPriorityListVal',
                getEvaluationScreenVal: 'TranslationStore/getEvaluationScreenVal',
                getAssessmentEndFinishData: 'ScoringStore/getAssessmentEndFinishData',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            }),

            languageListForDropdown() {

                let langsForDropdown = [];
                this.languageList.forEach((langKey) => {
                    langsForDropdown.push({
                        key: langKey,
                        name: this.text("api.language.name." + langKey)
                    });
                });
                return langsForDropdown;
            },

            selectedLang: {
                get() {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set(newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            },

            selectedTheme: {
                get() {
                    return this.$store.state["TranslationStore"].theme;
                },

                set(newVal) {
                    this.$store.commit('TranslationStore/setTheme', newVal)
                }
            },

            mustShowAssessmentList: {

                get() {
                    return this.$store.getters['SymptomsQuestionsStore/getMustShowAssessmentList'];
                },

                set(newVal) {
                    this.$store.commit('TranslationStore/setPriorityListVal', newVal);
                    if (newVal) {
                        this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", true).then((response) => {

                        });
                    } else {
                        this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", false).then((response) => {

                        });
                    }
                    if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                        if (newVal) {
                            this.$router.push('/symptoms-list');
                        } else {
                            this.$router.push('/symptoms-questions');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);

                    } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                        if (newVal) {
                            this.$router.push('/assessment-start-list');
                        } else {
                            this.$router.push('/assessment-start');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);

                    } else {
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);
                        this.settings = false;

                    }
                }

            },

            mustShowEvaluationPage: {
                get() {
                    return this.$store.getters['TranslationStore/getMustShowEvaluationPage'];
                },

                set(newVal) {
                    this.$store.commit('TranslationStore/setEvaluationScreenVal', newVal);
                    if (newVal) {
                        this.$store.dispatch("TranslationStore/submitEvaluationPageType", true).then((response) => {

                        });
                    } else {
                        this.$store.dispatch("TranslationStore/submitEvaluationPageType", false).then((response) => {

                        });
                    }
                }

            },

            isNotRequiredPage() {
                return this.$route.name === 'AssessmentStartPage' || this.$route.name === 'AssessmentStartListPage' || this.$route.name === 'ScoringPage';

            },
            isScoringPage() {
                return this.$route.name === 'ScoringPage';

            },

            pageWidth() {
                return this.$vuetify.breakpoint.width;
            }
        },

        methods: {
            // Store actions.
            ...mapActions({
                showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup',
                showPrintPdfPopup: 'ScoringStore/showPrintPdfPopup',
                showSummaryPopup: 'ScoringStore/showSummaryPopup',
                showMedicalDeviceInfoPopup: 'MedicalDeviceInfoStore/showMedicalDeviceInfoPopup',

            }),

            logOut() {
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },

            closeSideNav() {
              if(this.sideNav) {
                  this.sideNav = false;
              }
            },

            redirectToUrl() {
                let buttonFinishUrl = null;

                if (this.getAssessmentEndFinishData !== null
                    && typeof this.getAssessmentEndFinishData.buttonFinishUrl !== 'undefined'
                    && this.getAssessmentEndFinishData.buttonFinishUrl !== null) {

                    buttonFinishUrl = this.getAssessmentEndFinishData.buttonFinishUrl;
                }
                else if (this.getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON')
                         && this.getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON').length > 0) {

                    buttonFinishUrl = this.getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON');
                }

                if (buttonFinishUrl != null) {
                    window.location.href = buttonFinishUrl;
                }
                else {
                    alert("Url to redirect is missing");
                }
            },

            onAssessmentEndFinishButton() {
                const method = this.getAppPropertyValue('ASSESSMENT_END_FINISH_BUTTON_METHOD');
                if (method === 'GET') {
                    this.redirectToUrl();
                }
                else {
                    // For POST method, submit the form
                    this.UtilitiesPlugin.submitDataForm(false, null);
                }
            },

            quitAssessment() {

                axios.post(process.env.API_BASE_URL + '/assessment/cancelAssessment').then((response) => {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                        this.goToHomePage();
                    }
                    else {
                        alert("Unexpected error.");
                        console.error("Unexpected error! Couldn't cancel the assessment.");
                    }
                });
            },

            goToHomePage() {
                this.$router.push('/home');
            },

            goToAssessmentListPage() {
                this.$router.push('/assessment-list');
            },
            goToTestsPage() {
                this.$store.commit('TestStore/setGetTreeData', false);
                this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
                    this.$router.push('/tests');
                });
            },
            isPatientCommentChanged() {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },
            showCommentAction() {
                this.$store.commit('TranslationStore/setShowUserComment', !this.getShowUserComment);
                this.$store.commit('TranslationStore/setShowUserCommentNoShortcut', true);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', false);
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(event) {
                switch (event.keyCode) {
                    // Q
                    case 81:
                        // Alt + Q
                        if (!this.getUserData.embedded && !this.getMustShowVitalParamsForm) {
                            if (event.ctrlKey === false && event.altKey === true && event.shiftKey === false) {
                                // Activates "Quit" button
                                this.$router.push('/home');
                            }
                        }
                        break;

                    // S
                    case 83:
                        // Alt + S
                        if (event.ctrlKey === false && event.altKey === true && event.shiftKey === false) {
                            // Activates "Share" button in Scoring Page
                            if (this.isScoringPage) {
                                this.$router.push('/assessment-share');
                            }

                        }
                        break;
                }
            },

            setIsKeyboardNav(value) {
                this.$emit('setIsKeyboardNav', value);
            },

        },

        watch: {

            addInfoIcon(newValue) {
                this.addInfoIcon = newValue;
            },


            // Watch on sideNav to set the radio icon to a Svg.
            sideNav(newVal, oldVal) {
                // If we close the side menu we should replace the menu icon with the svg
                if (!newVal) {
                    this.$nextTick(() => {
                        let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
                        if (menuIcon) {
                            menuIcon.innerHTML = this.menuIconPlugin();
                        }
                    })

                }
            },

            getShowUserCommentNoShortcut(newValue) {
                this.$store.commit('TranslationStore/setShowUserCommentNoShortcut', newValue);
            },

        },
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .alerts-top.medical-device {
       // right: 180px !important;

        .comment-block {
            position: relative;
            right: 25px;
        }
    }

    .toolbar.toolbar--fixed.header {
        background-color: $color-elevation-background;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;

        .toolbar__content {

            .user {
                width: 18px;
                height: 18px;
                margin-right: 2px;
            }
        }

    }

    .btn-menu {
        max-width: 100%;

        .settings, .user {
            height: 36px;
            width: 36px;
            margin-right: 10px;

            &:first-of-type {
                margin-left: 5px !important;

                span {
                    position: relative;
                    top: 2px;
                }
            }
        }
    }



    .menu__content {

        .list__tile__action {
            min-width: 100%;

            .input-group.input-group--selection-controls {
                min-width: 100%;
            }
        }
    }

    .settings {
        font-weight: $font-size-medium;

    }

    .btn-logout-icon:hover {
        cursor: pointer;
    }

    .user-account {
        color: $color-headings-text;
    }


    .user-logged img, .account-settings img {
        width: 22px;
    }

    .account-settings img.account {
        position: relative;
        top: 5px;
        margin-right: 18px;

    }

    .account-settings img.logout {
        margin-right: 18px;
    }

    .user-logged .list__tile__title:first-of-type {
        height:  44px !important;

        img {
            position: relative;
            top: 10px;
            width: 32px;
            margin-right: 7px;
        }
    }

    hr {
        border-top: 1px solid $color-element-outline;
    }

    .header-menu-medical-device {
        .patients-info-top {
            position: relative;
            display: inline-block;
            margin-top: 15px;

            .page-title {
                position: relative;
                bottom: 0;
                // top: 15px;
                font-size: $font-size-default;
                color: $color-headings-text;
            }

            .topbar-patient-info-content {
                position: relative;
                left: 0 !important;
                // SMASSDEV - 1119
                font-size: $font-size-extra-small;
                // word-spacing: $word-spacing-extra-small;
                // line-height: $line-height-extra-small;
                // letter-spacing: $letter-spacing-extra-small;
                font-weight: normal;
                white-space: nowrap;

                color: $color-body-text;
            }
        }

        .menu-settings.btn {
            background-color: $color-block-background;
            // SMASSDEV - 1119
            font-size: $font-size-small;
            // word-spacing: $word-spacing-small;
            // line-height: $line-height-small;
            // letter-spacing: $letter-spacing-small;
            height: 36px;
            border: 1px solid $color-element-outline;
            border-radius: 4px;
            padding: 0 16px;
        }
        .menu-settings.btn.finish-button {
            border: 1px solid transparent !important;
        }

        .assessment-start-container .alerts-icon, .assessment-start-container .comment-svg {
            top: 0 !important;
        }

        .comment-block {
            right: 60px !important;

            img {
                width: 36px !important;
                height: 36px !important;
            }
        }
    }

   /* .patient-comment.input-group--text-field {
        position: absolute;
        right: 25px;
        min-width: 450px;
        top: 50px;
        z-index: 999;
        max-width:450px;

        .input-group__input  {
                background-color: #ffffff !important;
                top: -28px;
                position: relative;
                padding: 20px;
                border-radius: 5px;
                border: 1px solid #ffffff !important;
                -webkit-box-shadow: -4px -4px 27px -6px rgba(0,0,0,0.75);
                box-shadow: -4px -4px 27px -6px rgba(0,0,0,0.75);

                textarea {
                    padding: 8px;
                    border: 1px solid #efefef !important;
                    border-radius: 5px;
                }
        }
    }*/



</style>




// WEBPACK FOOTER //
// src/professional/components/shared/HeaderBarMedicalDevice.vue